import { useRef } from 'react';
import { Frame } from './Frame';
import { answerCrew } from '../lib/crew';
import { loadProfile, saveProfile } from '../lib/state';
import { track } from '../analytics';

/**
 * Permission, once (10 §10, K15 X-06, K26 P-01): its own screen, after the
 * card and before the crew's first job. One picture carries the promise — they
 * read your own cards and pin up the one thing they pulled out of them — so the
 * words can be three short lines instead of a paragraph nobody reads.
 * "Not now" is a real answer: the exercises carry on, the feed shows only By hand.
 */
export function Permission({ day, onAnswer }: { day: number; onAnswer: (crew: 'on' | 'off') => void }) {
  const answered = useRef(false);
  // Never waits on the network: the answer goes in the background and the
  // screen moves on (interview 5, a 27 s "Telling them…" on a cold start).
  const answer = (crew: 'on' | 'off') => {
    if (answered.current) return;
    answered.current = true;
    void answerCrew(crew);
    saveProfile({ ...loadProfile(), crew });
    track('crew_permission', { answer: crew });
    onAnswer(crew);
  };
  return (
    <Frame left={<span className="tag">Day {day} · your crew</span>}>
      <video className="permission-art" src="/art/crew-at-work.mp4" poster="/art/crew-at-work.jpg" autoPlay muted loop playsInline aria-label="Your crew at work on your ideas" />
      <h1>Your crew works from what you make.</h1>
      <p className="why" style={{ fontSize: 17 }}>They can make art and films and stories from your ideas.</p>
      <div className="stack" style={{ marginTop: 'auto' }}>
        <button className="btn" onClick={() => answer('on')}>Let them</button>
        <div className="row" style={{ justifyContent: 'center' }}>
          <button className="link" onClick={() => answer('off')}>Not now — keep them off</button>
        </div>
      </div>
    </Frame>
  );
}
